export default __webpack_public_path__ + "static/media/rock.c7e5b0ae.png";